module.exports = __webpack_public_path__ + "media/applause.d51b8d6c.mp3";